export default {
	api: {
		LENDING_SERVICE_URL: process.env.API_URL || "/localApi",
	},
};
